// extracted by mini-css-extract-plugin
export default {"entry":"ProjectEntry_entry__HLJEo","line":"ProjectEntry_line__SVaxP","perm":"ProjectEntry_perm__0aMu+","name":"ProjectEntry_name__AVZVC"};